const navigation = document.querySelector('.navigation') as HTMLElement;
window.addEventListener('scroll', () => {
  const windowVieport = document.documentElement.clientHeight;
  const scrollY = window.scrollY;
  const pageHeight = document.body.offsetHeight;
  if (scrollY >= 152) {
    navigation.style.display = 'block';
  }
  if (scrollY < 152) {
    navigation.style.display = 'none';
  }
  if (scrollY > pageHeight - windowVieport - 165) {
    navigation.style.display = 'none';
  }
});
